import {createSlice} from '@reduxjs/toolkit'

const initialSlice = {
  interviewData: [],
  totalDocs: 0,
  hasNextPage: true,
  hasPrevPage: false,
  totalPages: 0,
  loading: true,
}

const interviewSlice = createSlice({
  name: 'interview',
  initialState: initialSlice,
  reducers: {
    setInterviewData(state, action) {
      state.interviewData = action.payload?.docs
      state.totalDocs = action.payload.totalDocs
      state.hasNextPage = action.payload.hasNextPage
      state.hasPrevPage = action.payload.hasPrevPage
      state.totalPages = action.payload.totalPages
      state.loading = false
    },
    deleteInterview(state, action) {
      state.interviewData = state.interviewData.filter((item) => item._id !== action.payload)
    },
    addInterview(state, action) {
      state.interviewData.unshift(action.payload)
    },
    editInterview(state, action) {
      const index = state.interviewData.findIndex((item) => item._id === action.payload._id)
      state.interviewData[index] = action.payload
    },
  },
})

export const {setInterviewData, editInterview, addInterview, deleteInterview} =
  interviewSlice.actions
export default interviewSlice.reducer
